import { render, staticRenderFns } from "./InitializeProfile.vue?vue&type=template&id=4a3db473"
import script from "./InitializeProfile.vue?vue&type=script&lang=js"
export * from "./InitializeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports